const nuxtDirs = ["///./src", "components", "layouts", "middleware", "pages", "plugins", "store"];

interface Trace {
  callee: string | null;
  pathname: string | null;
  lineno: number | null;
  columnno: number | null;
}

class CustomError {
  stack?: NodeJS.CallSite[];

  constructor() {
    // Use V8's feature to get a structured stack trace
    const oldStackTrace = Error.prepareStackTrace;
    const oldLimit = Error.stackTraceLimit;
    try {
      Error.stackTraceLimit = 60; // <- we need at least one more than the default limit
      Error.prepareStackTrace = (_, structuredStackTrace) => structuredStackTrace;
      if ("captureStackTrace" in Error) {
        Error.captureStackTrace(this, CustomError);
      }
      // eslint-disable-next-line no-unused-expressions
      this.stack; // <- invoke the getter for 'stack'
    } finally {
      Error.stackTraceLimit = oldLimit;
      Error.prepareStackTrace = oldStackTrace;
    }
  }
}

function getCallSiteFilename(element: NodeJS.CallSite) {
  const isEval = element.isEval();
  return element.getFileName() ?? ((isEval && new URL(element.getEvalOrigin() ?? "a://").pathname) || null);
}

export function getLoggingContext(startingNumber = 2) {
  const { stack } = new CustomError();
  const trace: Trace = {
    callee: null,
    pathname: null,
    lineno: null,
    columnno: null,
  };
  // Account for browsers that convert type NodeJS.CallSite[] to type string.
  const stackArray =
    typeof stack === "string" ? ((stack as string)?.split("\n") as unknown as NodeJS.CallSite[]) : stack;

  const element =
    (stackArray?.slice(startingNumber)?.find((element) => {
      if (element && typeof (element as NodeJS.CallSite).isEval === "function") {
        const fileName = getCallSiteFilename(element as NodeJS.CallSite);
        // Make sure the trace filename comes from the ./src directory
        return nuxtDirs.some((dirname) => fileName?.startsWith(dirname + "/"));
      }
      return undefined;
    }) as NodeJS.CallSite) ?? undefined;

  if (element !== undefined) {
    trace.callee = element.getFunctionName();
    trace.pathname = getCallSiteFilename(element);
    trace.lineno = element.getLineNumber();
    trace.columnno = element.getColumnNumber();
  }

  return trace;
}
